// src/reasoningTests/ReasoningTestLayout.js
import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ReasoningTestConfiguration from './ReasoningTestConfiguration';
import ReasoningTestDashboard from './ReasoningTestDashboard';

const ReasoningTestLayout = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
          {t('reasoningTests.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('reasoningTests.subTitle')}
        </Typography>
      </Box>

      {/* Tabs Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="reasoning tests tabs">
          <Tab
            icon={<AssignmentIcon />}
            label={t('reasoningTests.configuration')}
            id="reasoning-tab-0"
            aria-controls="reasoning-tabpanel-0"
          />
          <Tab
            icon={<DashboardIcon />}
            label={t('reasoningTests.dashboard')}
            id="reasoning-tab-1"
            aria-controls="reasoning-tabpanel-1"
          />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ p: 3 }}>
        {tabValue === 0 && <ReasoningTestConfiguration />}
        {tabValue === 1 && <ReasoningTestDashboard />}
      </Box>
    </Box>
  );
};

export default ReasoningTestLayout;